import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import { isNil, includes } from 'ramda'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import CheckLogin from '../views/CheckLogin.vue'
import NotAuthorized from '../views/NotAuthorized.vue'
import Forms from '../views/Forms.vue'
import store from '@/store'

Vue.use(VueRouter);

// const formLinks = [
//   {
//     title: 'Incident Report', type: 'IncidentReportType', link: 'incident-report', description: 'All Types of Incidents', submitReturn: true, component: 'IncidentReport',
//   },
//   {
//     title: 'Manager Report', type: 'IncidentReportType', link: 'manager-report', description: 'Daily Report for Managers', manager: true, component: 'ManagerReport',
//   },
// ]
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/check-login',
    name: 'check-login',
    component: CheckLogin,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/coupons',
    name: 'coupons',
    component: () => import(/* webpackChunkName: "rare" */ '../views/Coupons.vue'),
  },
  // {
  //   path: '/display/cobbs/specials/:any',
  //   name: 'display',
  //   redirect: '/home',
  // },
  {
    path: '/display/:group/:boardId/:clientId',
    name: 'display',
    component: () => import(/* webpackChunkName: "display" */ '../views/Display.vue'),
    meta: {
      authNotRequired: true,
    }, // http://display.crcforms.com/display/hartsgarage/harts-garage-portrait/{serial}
  },

  {
    path: '/displays/:group/:boardId/:clientId',
    name: 'display',
    component: () => import(/* webpackChunkName: "display" */ '../views/Display2.vue'),
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/forms',
    name: 'forms',
    component: Forms,
  },
  {
    path: '/forms/:id',
    props: { default: true },
    component: Forms,
  },
  {
    path: '/information',
    name: 'information',
    component: () => import(/* webpackChunkName: "about" */ '../views/InfoBoard.vue'),
  },
  {
    path: '/location',
    name: 'location',
    component: () => import(/* webpackChunkName: "about" */ '../views/Location.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/messages',
    name: 'messages',
    component: () => import(/* webpackChunkName: "about" */ '../views/Messages.vue'),
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: NotAuthorized,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/request-off',
    name: 'request-off',
    component: () => import(/* webpackChunkName: "rare" */ '../views/RequestOff.vue'),
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import(/* webpackChunkName: "about" */ '../views/Schedule.vue'),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
  },
  {
    path: '/certificates',
    name: 'giftcertificates',
    component: () => import(/* webpackChunkName: "settings" */ '../views/GiftCertificates.vue'),
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: () => import(/* webpackChunkName: "about" */ '../views/Tasks.vue'),
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import(/* webpackChunkName: "about" */ '../views/Welcome.vue'),
  },
  {
    path: '/management/customers',
    name: 'customers',
    component: () => import(/* webpackChunkName: "manager" */ '../views/management/Customers.vue'),
    meta: {
      authManager: true,
    },
  },
  {
    path: '/management/display-boards',
    name: 'display-boards',
    component: () => import(/* webpackChunkName: "manager" */ '../views/management/DisplayBoards.vue'),
    meta: {
      authManager: true,
    },
  },
  {
    path: '/management/email',
    name: 'email',
    component: () => import(/* webpackChunkName: "manager" */ '../views/management/Email.vue'),
    meta: {
      authManager: true,
    },
  },
  {
    path: '/management/manage-coupons',
    name: 'manage-coupons',
    component: () => import(/* webpackChunkName: "manager" */ '../views/management/ManageCoupons.vue'),
    meta: {
      authManager: true,
    },
  },
  {
    path: '/management/manage-info-boards',
    name: 'manage-info-boards',
    component: () => import(/* webpackChunkName: "manager" */ '../views/management/ManageInfoBoards.vue'),
    meta: {
      authManager: true,
    },
  },
  {
    path: '/management/manage-requests-off',
    name: 'manage-requests-off',
    component: () => import(/* webpackChunkName: "manager" */ '../views/management/ManageRequestsOff.vue'),
    meta: {
      authManager: true,
    },
  },
  {
    path: '/management/reports',
    name: 'reports',
    component: () => import(/* webpackChunkName: "manager" */ '../views/management/Reports.vue'),
    meta: {
      authManager: true,
    },
  },
  {
    path: '/management/setup-tasks',
    name: 'setup-tasks',
    component: () => import(/* webpackChunkName: "manager" */ '../views/management/SetupTasks.vue'),
    meta: {
      authManager: true,
    },
  },
  {
    path: '/management/sms',
    name: 'sms',
    component: () => import(/* webpackChunkName: "manager" */ '../views/management/Sms.vue'),
    meta: {
      authManager: true,
    },
  },
  {
    path: '/management/submissions',
    name: 'submissions',
    component: () => import(/* webpackChunkName: "manager" */ '../views/management/Submissions.vue'),
    meta: {
      authManager: true,
    },
  },
  {
    path: '/management/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "manager" */ '../views/management/Users.vue'),
    meta: {
      authManager: true,
    },
  },
  { path: '*', redirect: '/home' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

function routeNeedsAuthorization (to: Route) {
  return !(to.meta && to.meta.authNotRequired)
}

function routeSetLocationQuery (to: Route) {
  if (to.query.loc && typeof to.query.loc === 'string') {
    window.localStorage.setItem('queryLocation', to.query.loc)
  }
}

function routeClearLocationQuery (to: Route) {
  window.localStorage.setItem('queryLocation', '')
}

function locationMatchesQuery (to: Route) {
  if (!to.query.loc || store.state.location.data.id === to.query.loc) return true
  return false
}

function routeNeedsManager (to: Route) {
  return (to.meta && to.meta.authManager)
}
function userLoggedIn () {
  return (store.state.user && store.state.user.auth && store.state.user.auth.id)
}

function userNull () {
  return (store.state.user && store.state.user.auth && store.state.user.auth.id === null)
}

function userHasLocation () {
  if (!store.state.location || !store.state.location.data || !store.state.location.data.id) return false
  return true
}

function locationIsMchenry () {
  if (store.state.location && !store.state.location.data && store.state.location.data.id === 'cobbsmchenry') return false
  return true
}

function addRedirectQuery (to: Route, route: string) {
  if (to.query.redirectUrl && typeof to.query.redirectUrl === 'string') {
    console.log('here000', `${route}?redirectUrl=${to.query.redirectUrl}`)
    return `${route}?redirectUrl=${to.query.redirectUrl}`
  } console.log('route22', route)
  return route
}

function userHasSettings () {
  return (store.state.user && store.state.user.auth && store.state.user.auth.phone)
}

function userIsManager () {
  return store.getters.manager
}

router.beforeResolve((to: Route, from: Route, next: Function) => {
  try {
    console.log('frompath: ', from.path)
    // if (locationIsMchenry() && from.path !== '/') {
    //   return next('/')
    // }
    console.log('before resolve: ', to)
    // if (to.fullPath === from.fullPath) return true
    if (routeNeedsAuthorization(to)) {
      if (!userLoggedIn()) {
        routeSetLocationQuery(to)
        if (userNull()) {
          return next(addRedirectQuery(to, '/login'))
        } return next(addRedirectQuery(to, '/check-login'))
      } if (!userHasSettings()) {
        if (to.name === 'settings') return next()
        return next(addRedirectQuery(to, '/settings'))
      }
      console.log('1010 :', to.name)
      if (to.name === 'location' || to.name) return next()
      if (userHasLocation() && locationMatchesQuery(to)) {
        routeClearLocationQuery(to)
        if (!routeNeedsManager(to) || userIsManager()) {
          console.log('here 999')
          return next()
        }
        return next('not-authorized')
      }
      return next(addRedirectQuery(to, '/location'))
    }
  } catch (e) {
    console.log('error: ', e)
    return next('/')
  } console.log('at bottom', to)
  try {
    return next()
  } catch (e) {
    console.log('error here: ', e)
    return next('/')
  }
})

export default router
